import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Edit3 } from 'react-feather';
import Table from '../ui/Table';
import Badge from '../ui/Badge';
import { CAMPOS_IMPORTE, PAGE_SIZE, SIN_VALOR, formatearImporte } from '../../features/precios';
import colors from '../../theme/colors';

const importeStyle = {
  display: 'block',
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
};

const botonEditarStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 10px',
  fontSize: '0.75rem',
  fontWeight: 600,
  borderRadius: '6px',
  border: `1px solid ${colors.borderStrong}`,
  background: '#fff',
  color: colors.text,
  cursor: 'pointer',
};

// Table invoca Cell con { original, value, row }: se desempaqueta aqui para no
// declarar propTypes en cada renderer.
const conFila = (render) => (celda) => render(celda.original);

const texto = (valor) => (typeof valor === 'string' && valor.trim() ? valor : SIN_VALOR);

const construirColumnas = (onEditar) => [
  {
    Header: 'Sede',
    id: 'centro',
    width: 170,
    Cell: conFila((f) => texto(f.centro)),
  },
  {
    Header: 'Código',
    id: 'codigocurso',
    width: 120,
    Cell: conFila((f) => <span style={{ fontWeight: 600 }}>{texto(f.codigocurso)}</span>),
  },
  {
    Header: 'Curso',
    id: 'curso',
    width: 260,
    Cell: conFila((f) => texto(f.curso)),
  },
  {
    Header: 'Tipo',
    id: 'tipo',
    width: 105,
    Cell: conFila((f) => (f.tipo ? <Badge variant="gray">{f.tipo}</Badge> : SIN_VALOR)),
  },
  ...CAMPOS_IMPORTE.map(({ key, label }) => ({
    Header: label,
    id: key,
    width: 135,
    Cell: conFila((f) => <span style={importeStyle}>{formatearImporte(f[key])}</span>),
  })),
  {
    Header: 'Acciones',
    id: 'acciones',
    width: 100,
    sortable: false,
    resizable: false,
    Cell: conFila((f) => (
      <button
        type="button"
        style={botonEditarStyle}
        onClick={() => onEditar(f)}
        aria-label={`Editar precio de ${f.codigocurso} en ${f.centro}`}
      >
        <Edit3 size={13} aria-hidden="true" />
        Editar
      </button>
    )),
  },
];

const TablaPrecios = ({ rows, onEditar }) => {
  const columnas = useMemo(() => construirColumnas(onEditar), [onEditar]);
  return <Table columns={columnas} data={rows} defaultPageSize={PAGE_SIZE} />;
};

TablaPrecios.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEditar: PropTypes.func.isRequired,
};

export default TablaPrecios;
